import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import {IApprDocItemState, ICom0110MState} from '../../models/com/com0110m_model';
  
const initialState: ICom0110MState = {
    apprDocList : [],   // 결재문서목록
    
    pageSize  : 20,     // 페이징건수
    current   : 0,      // 현재페이지
}

export const com0110m_Slice = createSlice({
    name: "com0108m_Slice",
    initialState: initialState,
    reducers: {
        initState: (state) => {
            Object.assign(state, {...initialState});
        },
        setApprDocList: (state, action:PayloadAction<IApprDocItemState[]>) => {
            state.apprDocList = action.payload;
        },
        setPageSize: (state, action:PayloadAction<number>) => {
            state.pageSize = action.payload;
        },
        setCurrent: (state, action:PayloadAction<number>) => {
            state.current = action.payload;
        },
    },
});

export default com0110m_Slice.reducer;
export const Com0110mAction  = com0110m_Slice.actions;
export const Com0110mReducer = com0110m_Slice.reducer;